
export class ProfileCountryDeleteModel {
  profileCountries: string[];
}
